export class ReferenceData {
    public id: string;
    public name: string;
}